<template>
  <v-dialog :value="showDialog" persistent max-width="650px">
    <v-card>
      <v-layout row wrap>
        <v-flex xs12>
          <template v-if="type === 'modal'">
            <DialogContainerModal
              :title="title"
              :icon="icon"
              :isLoading="isLoading"
              @onCancelClicked="$emit('onCancelClicked')"
            >
              <slot />
            </DialogContainerModal>
          </template>
          <template v-else>
            <DialogContainerConfirmation
              :title="title"
              :icon="icon"
              :isLoading="isLoading"
            >
              <slot />
            </DialogContainerConfirmation>
          </template>
        </v-flex>
        <v-flex xs12>
          <Toolbar
            :isDark="false"
            :actions="toolbarActions"
            :isLoading="isLoading"
            @onClicked="(val) => $emit(val)"
          />
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import Toolbar from './Toolbar'
import DialogContainerModal from './DialogContainerModal'
import DialogContainerConfirmation from './DialogContainerConfirmation'

export default {
  components: {
    Toolbar,
    DialogContainerModal,
    DialogContainerConfirmation,
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    title: String,
    icon: String,
    isLoading: Boolean,
    type: {
      type: String,
      default: 'modal',
    },
    toolbarActions: {
      type: Array,
      validator: (val) => {
        return val.every((action) => action.hasOwnProperty('emitEvent'))
      },
    },
  },
  data: () => ({}),
}
</script>